const image1 = require("../../images/profile-img.jpeg");
const image2 = require("../../images/profile-img.jpeg");
const image3 = require("../../images/profile-img.jpeg");
const image4 = require("../../images/profile-img.jpeg");
const image5 = require("../../images/profile-img.jpeg");
const image6 = require("../../images/profile-img.jpeg");
const image7 = require("../../images/profile-img.jpeg");
const image8 = require("../../images/profile-img.jpeg");

export const teamMembers = [
  {
    image: image1,
    name: "Tnip",
    designation: "Founder",
    index: "1",
  },
  {
    image: image2,
    name: "Lil'Misfit",
    designation: "Co-Founder",
    index: "2",
  },
  {
    image: image3,
    name: "Egg",
    designation: "Marketing",
    index: "3",
  },
  {
    image: image4,
    name: "Qais",
    designation: "UI-designer",
    index: "4",
  },
  {
    image: image5,
    name: "Tnip",
    designation: "Founder",
    index: "5",
  },
  {
    image: image6,
    name: "Lil'Misfit",
    designation: "Co-Founder",
    index: "6",
  },
  {
    image: image7,
    name: "Egg",
    designation: "Marketing",
    index: "7",
  },
  {
    image: image8,
    name: "Qais",
    designation: "UI-designer",
    index: "8",
  },
];
